import { ChevronLeftCircle } from "lucide-react"
import { useNavigate } from "react-router-dom"

export default function BackButton({ className, onClick }: { className?: string, onClick?: () => void }) {
    const navigate = useNavigate()

    return (
        <button
            onClick={ () => onClick ? onClick() : navigate(-1)}
            className={`text-gray-500 hover:text-gray-700 ${className||''}`}
        >
            <ChevronLeftCircle className="h-6 w-6" />
        </button>
    )
}